import { SelectOption } from 'tailwindComponents/selectTW/interfaces';
import { eConsumerTypes } from 'types/order/consumer/eConsumerTypes';
import { getSigningAppointmentOwnerTypeDisplayLabel } from '../../../../../../../utilities/order/scheduling/getSigningAppointmentOwnerTypeDisplayLabel';
import { labelComparator } from '../../../../../../../utilities/labelComparator';
import {
  eCreateSigningAppointmentFormDataOwnerTypes,
  getConsumerTypeFromFormDataOwnerType,
  getFormDataOwnerType,
} from '../../../../../../../types/order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';
import { eTransactionCategory } from 'ui-toolkit/enums/eTransactionType';
import { ePartyPurpose } from '../../../../../../../ui-toolkit/enums/ePartyPurpose';
import { IParty } from '../../../../../../../ui-toolkit/orders/interfaces/IParty';

const PartyPurposesByConsumerTypes: Map<ePartyPurpose, eConsumerTypes> = new Map([
  [ePartyPurpose.borrower, eConsumerTypes.borrower],
  [ePartyPurpose.buyer, eConsumerTypes.borrower],
  [ePartyPurpose.seller, eConsumerTypes.seller],
]);

const shouldIncludeConsumerType = (
  consumerType: eConsumerTypes,
  transactionCategory: eTransactionCategory,
  parties: IParty[],
  isCorrection: boolean,
  initialOwnerType?: eCreateSigningAppointmentFormDataOwnerTypes
): boolean => {
  if (transactionCategory === eTransactionCategory.Refinance && consumerType === eConsumerTypes.seller) {
    return false;
  }
  if (isCorrection && !!initialOwnerType) {
    return getConsumerTypeFromFormDataOwnerType(initialOwnerType) === consumerType;
  }
  return parties.some((party) => PartyPurposesByConsumerTypes.get(party.purpose) === consumerType);
};

const createOption = (
  consumerType: eCreateSigningAppointmentFormDataOwnerTypes,
  transactionCategory: eTransactionCategory,
  isCorrection: boolean
) => {
  const label = getSigningAppointmentOwnerTypeDisplayLabel(consumerType, transactionCategory, isCorrection);
  return {
    label,
    value: consumerType,
  };
};

const mapToOwnerTypes = (consumerType: eConsumerTypes): eCreateSigningAppointmentFormDataOwnerTypes[] => [
  getFormDataOwnerType(consumerType, true),
  getFormDataOwnerType(consumerType, false),
];

export const buildOwnerTypeOptions = (
  transactionCategory: eTransactionCategory,
  parties: IParty[],
  isCorrection: boolean,
  initialOwnerType?: eCreateSigningAppointmentFormDataOwnerTypes
): SelectOption[] => {
  return Object.values(eConsumerTypes)
    .filter((consumerType) =>
      shouldIncludeConsumerType(consumerType, transactionCategory, parties, isCorrection, initialOwnerType)
    )
    .flatMap((option) => mapToOwnerTypes(option))
    .map((ownerType) => createOption(ownerType, transactionCategory, isCorrection))
    .toSorted(labelComparator);
};
